import { render, staticRenderFns } from "./CopyToClipboardIcon.vue?vue&type=template&id=121ccaf8&scoped=true"
import script from "./CopyToClipboardIcon.vue?vue&type=script&lang=ts"
export * from "./CopyToClipboardIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121ccaf8",
  null
  
)

export default component.exports